import { render, staticRenderFns } from "./ArticleIcons.vue?vue&type=template&id=3f39cd6e&scoped=true&"
import script from "./ArticleIcons.vue?vue&type=script&lang=js&"
export * from "./ArticleIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f39cd6e",
  null
  
)

export default component.exports